import React from "react";
import { useSelector } from "react-redux";
import Informations from "../../service-steps/education/informations";
import FollowUp from "../../service-steps/education/follow-up";
import { calculateAgeYear } from "../../../../../helpers/functions";

const Education = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const { patient } = useSelector((state) => state.patients);
  const age = patient?.dateOfBirth ? calculateAgeYear(patient.dateOfBirth) : null;

  const renderStep = () => {
    const subStep = currentSubStep === 0 ? 1 : currentSubStep;
    // If patient is under 12, skip `case 1` and go to `case 2`
    const effectiveSubStep = age !== null && age < 12 && subStep === 1 ? 2 : subStep;
    switch (effectiveSubStep) {
      case 1:
        return <Informations />;
      case 2:
        return <FollowUp />;
    }
  };
  return renderStep();
};

export default Education;
